import { photoModeFilters } from '~/shared';
import { RpcService } from '../RpcService';
import { IPhotoModeService } from './photoModeServiceTypes';

export class PhotoModeService implements IPhotoModeService {
	constructor(private readonly rpc: RpcService) {}

	public async swapFilter(
		filter: (typeof photoModeFilters)[number],
	): Promise<void> {
		return await this.rpc.invokeClient('photoMode:swapFilter', { filter });
	}

	public async resetSettings(): Promise<void> {
		return await this.rpc.invokeClient('photoMode:resetSettings');
	}

	public async exit(): Promise<void> {
		await this.rpc.invokeClient('phone:closeApp:camera');
		await this.rpc.invokeClient('photoMode:exit');
	}
}
